import { eEstadoMaestro } from "../common/enumModel";
import { IFilterActoCondicionModel } from "../interfaces/acto-condicion/IFilterActoCondicionModel";

export class FilterActoCondicionModel implements IFilterActoCondicionModel {    
    idActoCondicion: number[];
    nombre: string;
    idEstado: eEstadoMaestro;
    page: number;
    pageSize: number;
    
    constructor(){
        this.idActoCondicion = new Array<number>();
        this.nombre = '';
        this.idEstado = eEstadoMaestro.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
    }
}